import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";

import { AddToCartErrorComponent, GroupedErrorNamesPipe } from "./add-to-cart-error.component";

@NgModule({
  declarations: [AddToCartErrorComponent, GroupedErrorNamesPipe],
  imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule],
  exports: [AddToCartErrorComponent, GroupedErrorNamesPipe],
})
export class AddToCartErrorModule {}
